export const categories = [
  {
    id: '0o65741345',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/categories/bags.webp',
    name: 'Bag',
    slug: 'bag',
    description: 'Practical Granite Chicken',
    products: 19,
  },
  {
    id: '0o54036233',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/categories/sunglass.webp',
    name: 'Sunglass',
    slug: 'sunglass',
    description: 'Oriental Plastic Gloves',
    products: 19,
  },
  {
    id: '0o24372456',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/categories/watch.webp',
    name: 'Watch',
    slug: 'watch',
    description: 'Recycled Frozen Gloves',
    products: 5,
  },
  {
    id: '0o12046444',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/categories/sneakers.webp',
    name: 'Sneakers',
    slug: 'sneakers',
    description: 'Luxurious Soft Shoes',
    products: 12,
  },
  {
    id: '0o50474030',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/categories/chair.webp',
    name: 'Chair',
    slug: 'chair',
    description: 'Fantastic Wooden Chairs',
    products: 35,
  },
  {
    id: '0o33766113',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/categories/tools.webp',
    name: 'Tools',
    slug: 'tools',
    description: 'Recycled Frozen Gloves',
    products: 18,
  },

  {
    id: '0o54047661',
    image:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/categories/kids.webp',
    name: 'Kids',
    slug: 'kids',
    description: 'Recycled Frozen Gloves',
    products: 15,
  },
];
